export default __webpack_public_path__ + "static/media/27.832452d2.png";